import { IdPathParameters, FindOperation } from '@infuse/api/common';
import { User } from '@infuse/api/iam/user';
import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';

export function useGenericUser({
  apiFn,
  queryKeys,
  onlyEnableWithParentId = false,
  initialParentId
}: {
  apiFn: FindOperation<User, string> | FindOperation<User, IdPathParameters<string>>;
  queryKeys: string[];
  onlyEnableWithParentId?: boolean;
  initialParentId?: string;
}) {
  const fetchUserId = ref<string | undefined>(undefined);
  const fetchParentId = ref<string | undefined>(initialParentId);

  const query = useQuery<User>({
    queryKey: [...queryKeys, 'detail', fetchParentId, fetchUserId],
    enabled: () => !!fetchUserId.value && (onlyEnableWithParentId ? !!fetchParentId.value : true),
    queryFn: () => {
      if (onlyEnableWithParentId && fetchParentId.value) {
        return apiFn({ id: fetchParentId.value, userId: fetchUserId.value });
      }
      return apiFn({ id: fetchUserId.value });
    }
  });

  const user = computed(() => query.data.value);

  return {
    ...query,
    user,
    fetchUserId,
    fetchParentId
  };
}
